<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="w-full flex justify-between items-center bg-blue-200 text-sm px-4 py-2 mb-4">
      提示：发布应用时，设置“验证类型”为“App注册码”，当打开发布的应用时输入在此用积分兑换的激活码进行授权。
    </div>
    <div class="sm:flex sm:justify-between sm:items-center">
      <select v-model="query.Status" name="Status" autocomplete="Status-name" class="sm:hidden mt-3 mr-4 w-48 inline-block bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <option :value="-1" :selected="query.Status === -1">全部</option>
        <option :value="1" :selected="query.Status === 1">已激活</option>
        <option :value="0" :selected="query.Status === 0">未激活</option>
      </select>
      <nav class="space-x-4 hidden sm:block pb-4 mt-3" aria-label="Tabs">
        <a href="#" @click="query.Status = -1" :class="[query.Status === -1 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">全部</a>
        <a href="#" @click="query.Status = 0" :class="[query.Status === 0 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">未激活</a>
        <a href="#" @click="query.Status = 1" :class="[query.Status === 1 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">已激活</a>
      </nav>
      <a @click="batchAdd" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto cursor-pointer">积分兑换</a>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">激活码</th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">应用名称</th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">兑换类型</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Code}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.AppName.length">{{item.AppName}}</span>
                    <span class="text-red" v-else>--</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.IsVip">Vip限免兑换</span>
                    <span class="text-red" v-else>积分兑换</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.CreateTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status === 1" class="text-green-600">已激活</span>
                    <span v-else-if="item.Status === 0">未激活</span>
                    <span class="text-red" v-else>--</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="view(item)" title="查看" v-if="item.Status === 1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="copy(item.Code)" title="点击复制激活码">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="addDialog" title="兑换激活码" @submit="batchCode()" submitText="兑 换" width="max-w-xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4">
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">激活码数量</label>
          </div>
          <div class="sm:col-span-3">
            <input v-model="addForm.Count" type="number" autocomplete="off" name="project-name" class="block sm:w-full md:w-2/6 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">激活码类型</label>
          </div>
          <div class="sm:col-span-3">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">
              <!-- <div class="flex items-center cursor-pointer" @click="addForm.CodeType = -1">
                <input name="notification-method" :value="-1" type="radio" :checked="addForm.CodeType === -1" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="email" class="ml-3 block text-sm font-medium text-gray-700"> 全部 </label>
              </div> -->

              <div class="flex items-center cursor-pointer" @click="addForm.CodeType = 0">
                <input name="notification-method" :value="0" type="radio" :checked="addForm.CodeType === 0" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="email" class="ml-3 block text-sm font-medium text-gray-700"> 在线 </label>
              </div>

              <div class="flex items-center cursor-pointer" @click="addForm.CodeType = 1">
                <input name="notification-method" :value="1" type="radio" :checked="addForm.CodeType === 1" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="sms" class="ml-3 block text-sm font-medium text-gray-700"> 离线 </label>
              </div>

              <div class="flex items-center cursor-pointer" @click="addForm.CodeType = 2">
                <input name="notification-method" :value="2" type="radio" :checked="addForm.CodeType === 2" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="push" class="ml-3 block text-sm font-medium text-gray-700">在线+离线 </label>
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">有效期天数</label>
          </div>
          <div class="sm:col-span-3">
            <input v-model="addForm.ValidityPeriodDay" type="number" autocomplete="off" name="project-name" class="inline-block sm:w-full md:w-2/6 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <div class="inline-block ml-1">0为无限期</div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2" v-if="user.is_vip">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">兑换类型</label>
          </div>
          <div class="sm:col-span-3">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">
              <div class="flex items-center cursor-pointer" @click="addForm.IsVip = false">
                <input name="is_vip" id="is_vip_false" :value="false" type="radio" :checked="addForm.IsVip === false" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="is_vip_false" class="ml-3 block text-sm font-medium text-gray-700"> 积分兑换 </label>
              </div>

              <div class="flex items-center cursor-pointer" @click="addForm.IsVip = true">
                <input name="is_vip" id="is_vip_true" :value="true" type="radio" :checked="addForm.IsVip === true" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="is_vip_true" class="ml-3 block text-sm font-medium text-gray-700"> Vip限免兑换 </label>
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2" v-if="!addForm.IsVip">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">需要积分</label>
          </div>
          <div class="sm:col-span-3">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">{{ parseInt(addForm.Count) * price }}</div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2" v-if="addForm.IsVip">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">剩余可兑换次数</label>
          </div>
          <div class="sm:col-span-3">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">{{ parseInt(user.vip_app_code_limit) - parseInt(user.use_vip_app_code) }}</div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal :visible.sync="detailDialog" title="激活码详情" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 my-4 mx-2 px-4 py-0" v-if="Object.keys(detail)">
        <div>
          <h2 class="text-base font-extrabold text-gray-900 mt-6">{{detail.AppName}}</h2>
        </div>
        <div class="mt-4 block">
          <div class="relative block box-border text-sm">
            <div class="text-gray-900 my-2"><span class="text-gray-500">应用Key：</span>{{detail.AppKey}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">应用版本：</span>{{detail.AppVersion}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">激活时间：</span>{{detail.ActivateTime}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">有效期：</span>{{detail.ValidityPeriodDay === 0 ? '无限期' : detail.ValidityTime}}</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, batchBuild, getPrice } from '../api/RegCode.js'
import { getCurrentUser } from '../api/App'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        Status: -1,
        sort: '-id'
      },
      detail: {},
      tableData: [],
      total: 0,
      addDialog: false,
      addForm: {
        Count: 1,
        UserId: 0,
        CodeType: 0,
        ValidityPeriodDay: 0,
        AppKey: '',
        AppName: '',
        IsVip: false
      },
      user: null,
      price: 0
    }
  },
  mounted () {
    this.getList()
    this.getUser()
    this.getPrice()
  },
  methods: {
    getPrice () {
      getPrice().then(res => {
        this.price = Math.abs(res.data.data.Score)
      }).catch(err => { console.log(err) })
    },
    getUser () {
      getCurrentUser().then(res => {
        this.user = res.data.data
      }).catch(err => { console.log(err) })
    },
    batchAdd () {
      this.addForm = {
        Count: 1,
        UserId: this.$store.state.user.id,
        CodeType: 0,
        ValidityPeriodDay: 0,
        AppKey: '',
        AppName: '',
        IsVip: this.user.is_vip
      }
      this.addDialog = true
    },
    batchCode () {
      this.addForm.Count = parseInt(this.addForm.Count)
      this.addForm.ValidityPeriodDay = parseInt(this.addForm.ValidityPeriodDay)
      if (!this.addForm.Count) {
        this.notifyShow({ title: '激活码数量非法！', type: 'warn' })
        return
      }
      if (this.addForm.IsVip) {
        const num = parseInt(this.user.vip_app_code_limit) - parseInt(this.user.use_vip_app_code)
        if (this.addForm.Count > num) {
          this.notifyShow({ title: '激活码数量不可大于剩余可兑换次数！', type: 'warn' })
          return
        }
      }
      batchBuild(this.addForm).then((res) => {
        if (res.data.state) {
          this.notifyShow({ title: '兑换激活码成功！' })
          this.addDialog = false
          this.getList()
        } else {
          this.notifyShow({ title: res.data.message, type: 'warn' })
        }
      }).catch((err) => { this.notifyShow({ title: err, type: 'warn' }) })
    },
    copy (text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '已复制到剪切板' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
            this.notifyShow({ title: '无法复制此文本：', type: 'error' })
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '已复制到剪切板' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
            this.notifyShow({ title: '无法复制此文本', type: 'error' })
          }
        )
      }
    },
    view (detail) {
      this.detail = detail
      this.detailDialog = true
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page ? data.page : 1
        this.total = data.total ? data.total : 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
